import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

/**
 * @param {{ title: string, children: React.ReactNode }} props
 */
function ManualeGiocoDetailSection({ title, children }) {
  if (!children) return null;
  return (
    <Box as="section" mb={8}>
      <Heading size="md" mb={4}>
        {title}
      </Heading>
      {children}
    </Box>
  );
}

export default ManualeGiocoDetailSection;
